function Pollytts(settings_params) {
    // include Polly from aws sdk.
    var Polly = require('aws-sdk/clients/polly');

    // presigner for Polly
    var presigner = new Polly.Presigner({
        region: settings_params.awsRegion,
        credentials: {
            accessKeyId: 'AKIASZTLHW7P5JA6LBOQ',
            secretAccessKey: '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'
        }
    });

    var TTS = {
        self: this,
        playlist: [],
        getAudioUrl: function(msg, VoiceId, ElementId) {
           
            var url = presigner.getSynthesizeSpeechUrl({
                TextType: 'text',
                OutputFormat: 'mp3',
                VoiceId: VoiceId,
                Text: msg
            });
            var audioElement = document.getElementById(ElementId);
            if (!!audioElement) {
                audioElement.src = url;
            }
        }

    }
    return TTS;
}

export default Pollytts;